import { StreamingPlayerError } from '@heardis/stream-contracts';

type PlausibleArgs = [string, { props: any }] | [string];

declare global {
  const plausible: {
    (...args: PlausibleArgs): void;
    q?: PlausibleArgs[];
  };

  interface Window {
    plausible?: typeof plausible;
  }
}

export enum PlausibleAnalyticsEventType {
  LINK_TO_SPOTIFY = 'toSpotify',
  TRACK_PLAY = 'trackPlay',
  TRACK_PAUSE = 'trackPause',
  TRACK_SEEK = 'trackSeek',
  GO_TO_NEXT_TRACK = 'toNextTrack',
  GO_TO_PREVIOUS_TRACK = 'toPreviousTrack',
  GO_TO_TRACK = 'toTrack',
  SHOW_DESCRIPTION = 'showDescription',
  SHOW_TRACKLIST = 'showTracklist',
  SHOW_NOTES = 'showNotes',
  PLAYER_ERROR = 'error',
  PAGE_RELOAD = 'pageReload',
  USER_LOGIN = 'userLogin',
  USER_LOGOUT = 'userLogout',
}

export type PlausibleAnalyticsEventAction =
  | { type: PlausibleAnalyticsEventType.LINK_TO_SPOTIFY; tId: string } // Should we also include the spotify ID here?
  | { type: PlausibleAnalyticsEventType.TRACK_PLAY; tId: string }
  | { type: PlausibleAnalyticsEventType.TRACK_PAUSE; tId: string }
  | { type: PlausibleAnalyticsEventType.TRACK_SEEK; tId: string }
  | { type: PlausibleAnalyticsEventType.GO_TO_NEXT_TRACK; tId: string; tIdCurr: string }
  | { type: PlausibleAnalyticsEventType.GO_TO_PREVIOUS_TRACK; tId: string; tIdCurr: string }
  | { type: PlausibleAnalyticsEventType.GO_TO_TRACK; tId: string; tIdCurr: string }
  | { type: PlausibleAnalyticsEventType.SHOW_DESCRIPTION }
  | { type: PlausibleAnalyticsEventType.SHOW_TRACKLIST }
  | { type: PlausibleAnalyticsEventType.SHOW_NOTES; tId?: string }
  | { type: PlausibleAnalyticsEventType.PLAYER_ERROR; err: StreamingPlayerError; tId?: string }
  | { type: PlausibleAnalyticsEventType.PAGE_RELOAD }
  | { type: PlausibleAnalyticsEventType.USER_LOGIN; user: string }
  | { type: PlausibleAnalyticsEventType.USER_LOGOUT; user: string };

export enum AnalyticsEventType {
  LINK_TO_SPOTIFY = 'hdis_link_to_spotify',
  TRACK_PLAY = 'hdis_track_play',
  TRACK_PAUSE = 'hdis_track_pause',
  TRACK_SEEK = 'hdis_track_seek',
  GO_TO_NEXT_TRACK = 'hdis_go_to_next_track',
  GO_TO_PREVIOUS_TRACK = 'hdis_go_to_previous_track',
  GO_TO_TRACK = 'hdis_go_to_track',
  SHOW_DESCRIPTION = 'hdis_show_description',
  SHOW_TRACKLIST = 'hdis_show_tracklist',
  SHOW_NOTES = 'hdis_show_notes',
  PLAYER_ERROR = 'hdis_player_error',
  PAGE_RELOAD = 'hdis_page_reload',
  USER_LOGIN = 'hdis_user_login',
  USER_LOGOUT = 'hdis_user_logout',
}

export type AnalyticsEventAction =
  | { type: AnalyticsEventType.LINK_TO_SPOTIFY; track_id: string } // Should we also include the spotify ID here?
  | { type: AnalyticsEventType.TRACK_PLAY; track_id_current: string }
  | { type: AnalyticsEventType.TRACK_PAUSE; track_id_current: string }
  | { type: AnalyticsEventType.TRACK_SEEK; track_id_current: string }
  | { type: AnalyticsEventType.GO_TO_NEXT_TRACK; track_id_current: string; track_id_target: string }
  | { type: AnalyticsEventType.GO_TO_PREVIOUS_TRACK; track_id_current: string; track_id_target: string }
  | { type: AnalyticsEventType.GO_TO_TRACK; track_id_current: string; track_id_target: string }
  | { type: AnalyticsEventType.SHOW_DESCRIPTION }
  | { type: AnalyticsEventType.SHOW_TRACKLIST }
  | { type: AnalyticsEventType.SHOW_NOTES; track_id?: string }
  | { type: AnalyticsEventType.PLAYER_ERROR; error: StreamingPlayerError; track_id?: string }
  | { type: AnalyticsEventType.PAGE_RELOAD }
  | { type: AnalyticsEventType.USER_LOGIN; username: string }
  | { type: AnalyticsEventType.USER_LOGOUT; username: string };
